/** Zod validation schemas for Knowledge Graph endpoints */

import { z } from 'zod'

export const graphQuerySchema = z.object({
  type: z.enum(['relates-to', 'depends-on', 'extends', 'references', 'contradicts', 'implements']).optional(),
  category: z.string().optional(),
  tag: z.string().optional(),
  minSimilarity: z.coerce.number().min(0).max(1).default(0.5).optional(),
})

export const graphNeighborsQuerySchema = z.object({
  depth: z.coerce.number().int().min(1).max(3).default(1).optional(),
  includeImplicit: z.coerce.boolean().default(true).optional(),
})

export const graphPathParamsSchema = z.object({
  from: z.string().min(1).describe('Source document ID'),
  to: z.string().min(1).describe('Target document ID'),
})

export const graphExtractionSchema = z.object({
  documentId: z.string().min(1),
  model: z.string().optional(),
})
